import type { ActiveGameData } from '@ps/web-poker-types';
import { ActiveGameButtonType } from '@ps/web-poker-types';
import { StarsButton as Button } from '@ps/web-shared-components';
import type React from 'react';
import { useCallback, useState } from 'react';

import { TXTCLI_Open, TXTCLI_Take_Your_Seat, TXTCLI_Unregister } from '../../translations';

import ConfirmButton from './ConfirmButton';
import styles from './GameItemButtons.module.scss';

interface Props {
  game: ActiveGameData;
  started?: boolean;
  hasStartTime?: boolean;
  onTakeSeat?: (game: ActiveGameData) => void;
  onUnregister?: (game: ActiveGameData) => void;
  onOpen?: (game: ActiveGameData) => void;
}

const GameItemButtons: React.FC<Props> = ({
  game,
  started,
  hasStartTime,
  onUnregister,
  onTakeSeat,
  onOpen
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleShowConfirm = useCallback(() => {
    setShowConfirm(true);
  }, []);

  const handleCancel = useCallback(() => {
    setShowConfirm(false);
  }, []);

  const handleUnregister = useCallback(() => {
    setShowConfirm(false);
    onUnregister?.(game);
  }, [game, onUnregister]);

  const handleTakeSeat = useCallback(() => {
    onTakeSeat?.(game);
  }, [game, onTakeSeat]);

  const handleOpen = useCallback(() => {
    onOpen?.(game);
  }, [game, onOpen]);

  const showUnregisterButton =
    !showConfirm && hasStartTime && !started && game.buttonType === ActiveGameButtonType.UNREGISTER;
  const showTakeSeatButton =
    !showConfirm && hasStartTime && (started || game.buttonType === ActiveGameButtonType.TAKE_SEAT);

  return (
    <div className={styles.buttonsWrap}>
      {showUnregisterButton && (
        <Button
          className={styles.unregister}
          variant="primary"
          translation={TXTCLI_Unregister}
          size="small"
          onClick={handleShowConfirm}
        />
      )}
      {showTakeSeatButton && (
        <Button
          variant="primary"
          translation={TXTCLI_Take_Your_Seat}
          size="small"
          onClick={handleTakeSeat}
        />
      )}
      {!hasStartTime && (
        <Button variant="primary" translation={TXTCLI_Open} size="small" onClick={handleOpen} />
      )}
      {showConfirm && <ConfirmButton onCancel={handleCancel} onConfirm={handleUnregister} />}
    </div>
  );
};

export default GameItemButtons;
